import React from "react";
import LineStatus from "colbi_web_ui/lib/components/rows/LineStatus/LineStatus";
import { SovosTooltip } from "mosaic-react";
import I18n from "../../../I18n";
import { importProfileStatusDescriptionKey } from "../../../utils/importProfileStatus";

export default function ImportProfileStatus(props) {
    const { value: cell } = props || {};
    const { tooltipKey, label, severity, family, color, status } = cell || {};
    const descriptionKey = tooltipKey || importProfileStatusDescriptionKey(status);
    const tooltip = I18n.translate(descriptionKey);
    const badge = <LineStatus value={{ label, severity, family, color }} />;

    if (!tooltip || tooltip === descriptionKey) {
        return badge;
    }

    return (
        <SovosTooltip title={tooltip} placement="top">
            <span style={{ display: "inline-flex" }}>{badge}</span>
        </SovosTooltip>
    );
}
